import { BenefitType, LimitType } from '@epi-constants/benefitTypes';
import { slideoutMode } from '@epi-constants/slideoutMode';
import { toComma } from '@epi-helpers/commaHelper';

export const ManageBenefitLunchFormFields = {
  BenefitGroupName: 'groupName',
  DailyLimit: 'maxAmountPerPeriod',
  FundsLoadingType: 'fundsLoadingType',
  IsMaximumSpendingLimit: 'isMaximumSpendingLimit',
  AutomaticRepeat: 'recurringTopupRequestEnabled'
};

export const viewModeInitialState = {
  mode: slideoutMode.view,
  expanded: false,
  currentGroupId: null,
  createdGroupNotification: false,
  createdGroupSuggestion: false
};

export const createModeInitialState = {
  mode: slideoutMode.create,
  expanded: true,
  currentGroupId: 0,
  createdGroupNotification: false,
  createdGroupSuggestion: false
};

export function getDailyLimitSelectFieldOptions(
  limits: number[],
  selectedLimit?: number
) {
  const isSelectedObsoleteLimit =
    selectedLimit && !limits.includes(selectedLimit);

  return (isSelectedObsoleteLimit ? [...limits, selectedLimit] : limits).map(
    limit => ({
      id: limit,
      display: toComma(`${limit.toFixed(2)} €`),
      upToDate: limits.includes(limit)
    })
  );
}

export function mapFormToBenefitGroup(form, benefitGroup, benefitType) {
  const { isMaximumSpendingLimit, ...restForm } = form;

  return {
    ...benefitGroup,
    ...restForm,
    benefitType,
    ...(benefitType === BenefitType.Lunch && {
      isMaximumSpendingLimit: isMaximumSpendingLimit === LimitType.maximum
    }),
    maxAmountPerPeriod: Number(
      form.maxAmountPerPeriod.toString().replace(',', '.')
    )
  };
}
